import React, { PropTypes, Component } from 'react';

import {
  NitroTabs,
  NitroBadge,
  NitroLoading,
  NitroSearchBar,
  NitroButton
} from 'nitro-components';

import styled from 'styled-components';

import Header from '../../../components/layouts/Header';
import ReportsCards from '../components/ReportsCards';
import {
  FilterGroup,
  CountryFilter,
  CostcenterFilter
} from '../../../components/filter';
import { updateCurrentRole } from '../../../components/common/Profile/utils';

import FilterMobileComponent from '../../../components/common/FilterMobileComponent';

import Breakpoint from '../../../utils/breakpoints';

import NewReport from '../new-report';

import Container from '../../../components/layouts/Container';

import { pushGAAction } from '../../../utils/gtm';

import { searchReports } from '../helper';

import * as routes from '../../../routes/const';

const SchedulingReportSource = styled.div`
  margin-top: 26px;
  height: 40px;
`;

const ScheduleTab = styled.div`
  padding: 14px;
  padding-right: 0;
`;

const PageContainer = styled.section`
  background-color: ${props => props.theme.color.secondary};
  position: absolute;
  width: 100%;
  left: 0px;
`;

const ParentContainer = styled.div`
  text-align: center;
`;

const OuterContainer = styled.div`
  display: flex;
`;

const TabsContainer = styled.div`
  justify-content: center;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  padding-top: 15px;
  color: ${props => props.theme.color.white};
`;

const FilterContainer = styled.div`
  display: block;
  height: 30px;
`;

const TabContent = styled.div`
   /*background-color: ${props => props.theme.color.border};*/
   background-color:#f7f7f7;
   padding: 1px 0 10px 0;
`;

class SchedulingReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchWord: '',
      reports: props.reports,
      isOpen: false
    };
    this.newReport = null;
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      reports: nextProps.reports
    });

    if (nextProps.scheduled !== this.props.scheduled) {
      this.setState({
        reports: searchReports(this.state.searchWord, nextProps.reports)
      });
    }
  }

  open = () => {
    const { country, costcenter } = this.props;
    this.props.actions.setCountry(country);
    this.props.actions.setCostcenter(costcenter);

    this.setState({
      isOpen: true
    });
  };

  close = () => {
    this.setState({
      isOpen: false
    });

    this.props.actions.setBusinessReport({});
    this.newReport.getWrappedInstance().goToStep(0, 0);
  };

  postCreate = () => {
    const { router } = this.context;
    this.close();
    this.props.notify({
      title: 'Success',
      message: 'You have successfully created new user report.'
    });
    router.push(routes.RB_MY_REPORTS);
  };

  switchTabs = tab => {
    const { router } = this.context;
    router.push(tab.route);
  };

  search = value => {
    this.setState({
      searchWord: value,
      reports: searchReports(value, this.props.reports)
    });
  };

  setSource = filters => {
    const country = filters[0];
    const costcenter = filters[1];
    this.props.setGlobalCountryCostCenter({ country, costcenter });

    if (this.props.role.country !== country.value) {
      const costCenters = filters;
      // update role when country is changed in filter
      updateCurrentRole(
        this.props.roles,
        costCenters,
        country.value,
        'ROLEDRAWERCHANGE',
        newRole => {
          this.props.setGlobalDynamicFilter([]);
          this.props.changeCurrentRole(newRole);
          this.context.router.push(routes.INSIGHTS);
        }
      );
    }
  };

  exportReport = (report, getExportCallback) => {
    const { country, costcenter, restrictions } = this.props;
    const companyCode = costcenter.value;
    const countryCode = country.value;
    let params = { ...report, title: report.name };

    switch (report.category) {
      case 'business':
        params = Object.assign({}, params, {
          companyCode,
          countryCode,
          restrictions
        });
        break;
      case 'legacy':
        params = Object.assign({}, params, { companyCode, countryCode });
        break;
    }

    pushGAAction(
      'BIZREPORT',
      `EXPORT::${report.name}::${countryCode}::${companyCode}`
    );
    this.props.exportReport({ ...params }, getExportCallback);
  };

  render() {
    const {
      category,
      total,
      scheduled,
      switchScheduled,
      fetchingReports,
      country,
      costcenter
    } = this.props;


    const scheduleTabs = [
      {
        label: 'All',
        key: 'all'
      },
      {
        icon: 'schedule',
        label: 'Scheduled',
        key: 'scheduled'
      }
    ];

    if (fetchingReports) {
      return <NitroLoading position="center" />;
    }

    const source = [
      {
        mandatory: true,
        title: 'Country',
        value: country && country.value,
        label: country && country.label,
        component: CountryFilter
      },
      {
        mandatory: true,
        title: 'Cost Centre',
        value: costcenter && costcenter.value,
        label: costcenter && costcenter.label,
        component: CostcenterFilter
      }
    ];

    return (
      <PageContainer>
        <Container>
          <OuterContainer>
            {this.props.category != 'legacy' && (
              <NitroButton
                label="CREATE MY REPORT"
                action={this.open}
                size="small"
                variant="primary"
              />
            )}
          </OuterContainer>
        </Container>

        <TabContent>
            <Container>
            {(this.state.reports.length > 0 ||
              this.props.category == 'user') && (
              <NewReport
                isOpen={this.state.isOpen}
                category="business"
                close={this.close}
                postCreate={this.postCreate}
                ref={nr => (this.newReport = nr)}
                isEditMode={false}
              />
            )}{' '}
            <section>
                <Header margin="10px 0 25px">
                <Breakpoint name="desktop">
                    <FilterContainer>
                    <FilterGroup
                        action={this.setSource}
                        title="Source"
                        icon="source"
                        filters={source}
                        align="right"
                    />
                  </FilterContainer>
                  </Breakpoint>
                <Breakpoint name="mobileTablet">
                      <FilterMobileComponent
                    onClickSource={this.setSource}
                    source={source}
                  />
                    </Breakpoint>

                  <SchedulingReportSource>
                  <NitroSearchBar
                    float="left"
                    hintText={
                      category === 'user'
                        ? 'Search my reports'
                        : 'Search business reports'
                    }
                    action={this.search}
                  />

                  {scheduled && (
                  <ScheduleTab>
                          <NitroTabs
                        lineHeight={12}
                        right
                        data={scheduleTabs}
                        active={scheduled}
                        action={switchScheduled}
                        divider
                      />
                        </ScheduleTab>
                  )}
                </SchedulingReportSource>
              </Header>

                  <ReportsCards
                  reports={this.state.reports}
                  exportReport={this.exportReport}
              />
              </section>
          </Container>
          </TabContent>
      </PageContainer>
    );
  }
}

SchedulingReports.propTypes = {
  scheduled: PropTypes.string,
  switchScheduled: PropTypes.func,
  fetchingReports: PropTypes.bool,
  category: PropTypes.string,
  reports: PropTypes.arrayOf(),
  total: PropTypes.shape({}),
  actions: PropTypes.shape({}),
  globalActions: PropTypes.shape({}),
  country: PropTypes.shape({}),
  costcenter: PropTypes.shape({}),
  exportReport: PropTypes.func,
  notify: PropTypes.func,
  restrictions: PropTypes.arrayOf(PropTypes.shape({}))
};

SchedulingReports.contextTypes = {
  router: PropTypes.shape({})
};

export default SchedulingReports;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/SchedulingReports/SchedulingReports.js